import React from 'react';
import Header from './header';
import Footer from './footer';
import '../../styles/layout.css';
import * as styles from './layout.module.css';
import { cn } from '../../lib/helpers';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const theme = createTheme();

const useStyles = makeStyles((theme) => {
  root: {
    // some CSS that accesses the theme
  }
});

const Layout = ({
  children,
  fixedNav,
  siteTitle,
  siteSubtitle,
  heroImageCaption,
  headerBackgroundImage,
  smallHeader = false,
  dark = false,
}) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <Header
        smallHeader={smallHeader}
        fixedNav={fixedNav}
        backgroundImage={headerBackgroundImage}
        siteTitle={siteTitle}
        siteSubtitle={siteSubtitle}
        heroImageCaption={heroImageCaption}
      />
      <div className={cn(styles.content, dark ? styles.darkContent : '')}>{children}</div>
      <Footer />
    </ThemeProvider>
  </StyledEngineProvider>
);

export default Layout;
